import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { Observable, catchError, of, switchMap } from "rxjs";
import { Utilities } from "../utils/utilities";
import { environment } from "@environments/environment";
import { AuthService } from "../services/auth.service";

export const RedirectGuard: CanActivateFn = (_, state): Observable<boolean | UrlTree> => {
  const util = inject(Utilities);
  const router = inject(Router);
  const auth = inject(AuthService);

  auth.removeUserData(state.url);

  const currentUserSession: Observable<any> = auth.getUserSession();

  return currentUserSession.pipe(
    switchMap((session: any) => {
      util.currentUserSession.set(session);
      const email = environment.authDisable ? session.getIdToken().decodePayload()["email"] : session.tokens.idToken.payload.email;
      return auth.setUserData(email, state.url);
    }),
    catchError(() => {
      console.log("ERROR : User session error");
      util.removeCountryInstitutionDetails();
      if (["/login"].includes(state.url))
        return of(true);
      else
        return of(router.createUrlTree(['/login']));
    })
  );
};
